import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  "txt-center": "",
  style: {"min-height":"60px","padding":"10px 20px"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { "txt-center": "" }
const _hoisted_6 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form_title = _resolveComponent("app-form-title")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_AppResetSucc = _resolveComponent("AppResetSucc")!
  const _component_AppResetLinkWrong = _resolveComponent("AppResetLinkWrong")!
  const _component_lock = _resolveComponent("lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_app_password_strength = _resolveComponent("app-password-strength")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_form_holder = _resolveComponent("app-form-holder")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_form_holder, null, {
      default: _withCtx(() => [
        (_ctx.isKeyValid === true && _ctx.finishedReset === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_app_form_title, { title: "Provide a new password" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Enter your new password. ", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_image, {
                  lazy: "",
                  style: `width: 160px;`,
                  src: _ctx.img
                }, null, 8, ["src"])
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (_ctx.finishedReset === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_AppResetSucc)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isKeyValid === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_AppResetLinkWrong)
              ]))
            : _createCommentVNode("", true),
          (_ctx.finishedReset === false && _ctx.isKeyValid === true)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 2,
                rules: _ctx.rules,
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_form_item, {
                      prop: "password",
                      label: "Password"
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_lock)
                          ]),
                          _: 1
                        }),
                        _cache[4] || (_cache[4] = _createTextVNode(" Password ", -1))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "********",
                          type: "password",
                          modelValue: _ctx.form.password,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_app_password_strength, {
                      password: _ctx.form.password
                    }, null, 8, ["password"])
                  ]),
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    error: 
              _ctx.confirmPassword.length > 0 && _ctx.confirmPassword !== _ctx.form.password
                ? `Passwords provided don't match`
                : ''
            
                  }, {
                    label: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_lock)
                        ]),
                        _: 1
                      }),
                      _cache[5] || (_cache[5] = _createTextVNode(" Confirm Password ", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "********",
                        type: "password",
                        modelValue: _ctx.confirmPassword,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_button, {
                      disabled: 
                !_ctx.form.password ||
                !_ctx.confirmPassword ||
                _ctx.form.password !== _ctx.confirmPassword
              ,
                      "is-block": "",
                      size: "large",
                      type: "primary",
                      icon: "el-icon-check",
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" Save New Password ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model"]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_space, {
            "w-100": "",
            fill: true,
            alignment: "center",
            direction: "vertical",
            size: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, { type: "primary" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("Sign In", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}